/* istanbul ignore file */
import { CreatePageLayout } from 'framework/ui/layout';
import useEmployeeOfferService from 'domain/people/employee/offers/shared/employeeOfferService';
import { CreateForm } from 'framework/form';
import EmployeeOfferForm from 'domain/people/employee/offers/createupdate/EmployeeOfferForm';
import { useEmployeeId } from 'domain/people/employee/employeeIdentityRouting';
import { useShowContext } from 'framework/show';
import { useEmployeeUrl } from 'domain/shared/employee';
import { CalculatePercentileModalButton } from 'domain/shared/performanceMeasurement';
import { Location, useLocation } from 'react-router-dom';
import { EmployeeOfferState } from 'domain/people/employee/offers/shared/offerTypes';

const CalculatePercentileButtonWithEmployeePosition: React.FC = () => {
  const { data } = useShowContext();
  const positionId = data?.positionId;
  const technologyId = data?.specializationInfo?.technologyId;
  const initialPosition = positionId ? `${positionId}${technologyId ? `--${technologyId}` : ''}` : null;
  return <CalculatePercentileModalButton initialPosition={initialPosition} size="small" />;
};

const CreateEmployeeOfferPage = () => {
  const { create, getValidationSchema } = useEmployeeOfferService();
  const employeeId = useEmployeeId();
  const { getTimelineUrl } = useEmployeeUrl();
  const location: Location<EmployeeOfferState> = useLocation();
  const initialOffer = location.state?.initialOffer;

  return (
    <CreateForm
      initialData={initialOffer || { offerCompensations: [] }}
      submitFormFunc={create}
      afterSubmit={{
        redirect: getTimelineUrl(employeeId || ''),
        message: 'You are awesome! The offer has been successfully created.',
      }}
      getValidationSchemaFunc={getValidationSchema}
    >
      <CreatePageLayout
        title="Create: Offer"
        titleVariant="h4"
        titleActions={<CalculatePercentileButtonWithEmployeePosition />}
      >
        <EmployeeOfferForm />
      </CreatePageLayout>
    </CreateForm>
  );
};

export default CreateEmployeeOfferPage;
